import React from 'react'
import PropTypes from 'prop-types'
import {
  Search
} from '@scuf/common'

import {
  InputsContainer
} from '../../tags.styles'
import ActionBar from 'Components/ActionBar'
import ActionContainer from '../action-container'
import { translate } from 'react-translate'
import { defaultFlags, flagsPropTypes } from 'Utils/launch-darkly-flags'
import { SimpleRow } from 'Components/AssetManagementBase/asset-management-base.styles'
import { UnlicensedTooltip } from 'Containers/AssetsDetails/collapse'

const Controls = ({
  editRemove,
  onAdd,
  onEdit,
  onRemove,
  permissions,
  flags,
  deviceDbStatus,
  t,
  ...rest
}) => {
  const isUnLicensedDevice = (flags.licensing && deviceDbStatus === 'unlicensed')
  return (
    <InputsContainer>
      <ActionBar>
        <ActionBar.Section>
          <div hidden={true}>
            <Search />
          </div>
        </ActionBar.Section>
        {/* <UnlicensedTooltip
          position='top center'
          content= 'renew'
          disabled={deviceDbStatus === 'active'}
          > */}
            <SimpleRow disabled={isUnLicensedDevice}>
              <ActionBar.Section>
                {permissions['tagging:create'] && 
                ( <UnlicensedTooltip
                  position='top center'
                  content='AddNewTag' // Pass the tooltip content for adding a new tag
                  disabled={isUnLicensedDevice} // Disable tooltip if the device is unlicensed
                >
                  <ActionContainer
                    description={t('AddTag')}
                    disabled={false}
                    label={t('NewTag')}
                    data-testid='newTagButton'
                    name='add'
                    onClick={onAdd}
                    root='building'
                    size='small'
                  />
                </UnlicensedTooltip>
              )
                }
                {permissions['tagging:edit'] &&
                ( <UnlicensedTooltip
                  position='top center'
                  content='EditTag' // Pass the tooltip content for adding a new tag
                  disabled={isUnLicensedDevice} // Disable tooltip if the device is unlicensed
                >
                  <ActionContainer
                    description={t('Edit')}
                    disabled={!editRemove}
                    label={t('Edit')}
                    data-testid='editTagButton'
                    name='edit'
                    onClick={onEdit}
                    root='common'
                    size='small'
                  />
                  </UnlicensedTooltip>
                )
                }
                {permissions['tagging:delete'] &&
                ( <UnlicensedTooltip
                  position='top center'
                  content='RemoveTag' // Pass the tooltip content for adding a new tag
                  disabled={isUnLicensedDevice} // Disable tooltip if the device is unlicensed
                >
                  <ActionContainer
                    description={t('RemoveFromDevices')}
                    disabled={!editRemove}
                    label={t('RemoveFromDevices')}
                    data-testid='deleteTagButton'
                    name='delete'
                    onClick={onRemove}
                    root='common'
                    size='small'
                  />
                  </UnlicensedTooltip>
                )
                  }
              </ActionBar.Section>
            </SimpleRow>
            {/* </UnlicensedTooltip> */}
      </ActionBar>
    </InputsContainer>
  )
}

Controls.defaultProps = {
  t: PropTypes.func,
  flags: defaultFlags,
}

Controls.propTypes = {
  editRemove: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
  flags: flagsPropTypes,
  permissions: PropTypes.object,
  t: () => null
}

export default translate('TaggingView')(Controls)
